import { render, staticRenderFns } from "./SecondForm.vue?vue&type=template&id=b370006a&"
import script from "./SecondForm.vue?vue&type=script&lang=js&"
export * from "./SecondForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports